<template><div class="main">

<div class="primary cap">
	<div class="d-flex justify-center align-center"> Chat </div>
	<div class="d-flex justify-start align-center pr-3 krest">
		<v-btn icon color="white" @click="$emit('close_chat')"> <v-icon> {{ $mdi.Close }} </v-icon> </v-btn>
	</div>
</div>

<div class="d-flex justify-space-between align-center px-1">
	<v-btn icon @click="settings=true"> <v-icon> {{ $mdi.Cog }} </v-icon> </v-btn>
	<span class="text-h6"> #{{rooms[room].title}} </span>

	<v-menu offset-y model="room">
	  <template v-slot:activator="{ on, attrs }">
	    <v-btn
	      color="primary"
	      dark outlined small
	      v-bind="attrs"
	      v-on="on"
	    >
	      Change room
	    </v-btn>
	  </template>
	  <v-list>
	    <v-list-item
	      v-for="(r, index) in rooms"
	      :key="index"
	      @click="change_room(index)"
	    >
	      <v-list-item-title> #{{ r.title }}</v-list-item-title>
	    </v-list-item>
	  </v-list>
	</v-menu>
</div>

<v-divider> </v-divider>

<div ref="message_box" class="message_box pa-2">
	<div v-for="(M,i) in msg_db[rooms[room].id]">
		<div v-if="!M.is_deleted"> 
			<div
				v-if="!(i > 0 && same_author(msg_db[rooms[room].id][i-1], M))"
				class="author pt-2"
				v-text="M.author.name"
			></div>

			<div v-if="M.reply_to" class="reply d-flex">
				<v-icon class="pa-2"> {{ $mdi.CommentQuote }} </v-icon>
				<div class="d-flex align-center" v-if="M.reply_to.is_deleted"> Original message was deleted</div>
				<div v-else>
					<div
						class="author pt-2"
						v-text="M.reply_to.author.name"
					></div>
					<div v-if="M.reply_to.attachment" class="text--secondary"> <v-icon> {{ $mdi.FileMultiple }} </v-icon> [attachment] </div>
					<div class="message_content">{{ shorten(M.reply_to.text) }}</div>
				</div>
			</div>
			
			<v-text-field
				autofocus
				v-if="message_being_edited == M"
		        v-model="M.text"
		        @keydown.enter="edit"
		        @keydown.escape="message_being_edited = null"
		        @blur="edit"
		        dense
		    ></v-text-field>
			<div v-else @click="open_menu($event, M)"
				:class="{msg_for_highlight: !showMenu, msg_under_menu: M == message_under_menu}"
			>
				<div v-if="M.attachment" class="text--secondary"> <v-icon> {{ $mdi.FileMultiple }} </v-icon> [attachment] </div>
				<div class="message_content">{{ M.text }}</div>
			</div>
		</div>
	</div>
</div>

<div v-if="message_for_reply" class="replying_to">Replying to {{ message_for_reply.author.name }} </div>

<v-divider> </v-divider>
<div class="d-flex" style="xflex: 0 1 auto" >
	<v-text-field
		ref="type_msg_field"
		:autofocus="$vuetify.breakpoint.mdAndUp"
		label="Type your message..."
		solo dense v-model="type_msg"
		@keydown="handle_keydown"
		hide-details flat
	></v-text-field>

	<v-menu
	      :close-on-content-click="false"
	      :nudge-width="200"
	      offset-x
	      class="mb-5"
	    >
	      <template v-slot:activator="{ on, attrs }">
	        <v-btn
	          v-bind="attrs"
	          v-on="on"
	          icon dark
	        >
	          😀
	        </v-btn>
	      </template>
	      <v-card class="pa-2 emoji_card" >
	      	<span v-for="n in 70" @click="type_msg+=String.fromCodePoint(0x1F600+n)"> 
	      		{{ String.fromCodePoint(0x1F600+n) }}
	      	</span>
	      </v-card>
	</v-menu>

	<v-btn icon color="blue" @click="send"> <v-icon> {{ $mdi.Send }} </v-icon> </v-btn>
</div>


<v-dialog
  v-model="settings"
  width="500"
>

  <v-card>
    <v-card-title class="headline grey lighten-2">
     Settings
    </v-card-title>

    <v-col >
      <v-text-field
        label="Nickname"
        v-model="type_nickname"
      ></v-text-field>
    </v-col>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        text
        @click="change_nickname"
      >
        OK
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>


<v-menu v-model="showMenu" absolute :position-y="menu_position.y" :position-x="menu_position.x" @blur="message_under_menu=null">
  <v-list>
    <v-list-item
      v-for="(item, index) in menu_items"
      :key="index"
      @click="handle_menu_click(item)"
    >
      <v-list-item-title>{{ item | t }}</v-list-item-title>
    </v-list-item>
  </v-list>
</v-menu>

</div></template>

<script>


function random_string(n) {
	let res = '';
	for (let i=0; i < n; i++) {
		res += "abcdefghijklmnopqrstuvwxyz0123456789"[Math.floor(Math.random()*36)]
	}
	return res;
}

if (localStorage.user_id === undefined) {
	localStorage.user_id = random_string(10);
	localStorage.password = random_string(20);
}
let user_id = localStorage.user_id;
let password = localStorage.password;

import io from 'socket.io-client';

let socket1_url, socket2_url;

let rooms;

if (process.env.NODE_ENV === 'development') {
	socket1_url = "http://localhost:3030";
	socket2_url = "http://localhost:3032";
	rooms = [
		{id: 'test', title: 'test'},
		{id: 'tratata', title: 'tratata'},
		{id: 'eng', title: 'english'},
		{id: 'rus', title: 'russian'},
		{id: 'nao', title: 'nao'},
	];

}
else {
	socket1_url = "https://bot-nao.herokuapp.com";
	socket2_url = "https://naobot2.herokuapp.com";
	rooms = [
		{id: 'eng', title: 'english'},
		{id: 'rus', title: 'russian'},
		{id: 'nao', title: 'nao'},
		{id: 'spam', title: 'spam'},
	]
}

let socket;
let socket1 = io(socket1_url, {autoConnect: false});
let socket2 = io(socket2_url, {autoConnect: false});

let my_last_message;

function getVerticalScrollPercentage(e){
	return e.scrollTop / (e.scrollHeight - e.offsetHeight);
}

let msg_db = {};
for (let r of rooms) msg_db[r.id] = [];


let state = {
	rooms,
	room: 0,
	settings: false,
	type_msg: '',
	showMenu: false,
	message_under_menu: null,
	menu_position: {x: 0, y: 0},
	menu_items: ['Edit','Delete','Reply'],
	message_being_edited: null,
	message_for_reply: null,
	msg_db,
	nickname: localStorage.nickname || 'guest_' + user_id,
	type_nickname: null,
};

export default {
	components: {},
	data() {
		return state;
	},
	watch: {
		showMenu(new_value) {
			if (new_value == false) this.message_under_menu = null;
		},
		settings(new_value) {
			if (new_value == true) {
				this.type_nickname = this.nickname;
			}
		},
		message_being_edited(new_value) {
			console.log("message_being_edited = ", new_value);
		}
	},
	methods: {
		open_menu(e, M) {
			if (this.showMenu == true) return;

			this.message_under_menu = M;
			this.menu_position.x = e.clientX;
			this.menu_position.y = e.clientY;
			this.showMenu = true;
		},
		handle_menu_click(action) {

			if (action == 'Delete' && this.message_under_menu.author.id == user_id) {
				this.message_under_menu.is_deleted = true;
				socket.emit('delete', this.rooms[this.room].id, this.message_under_menu.id.Website);
			}
			else if (action == 'Edit' && this.message_under_menu.author.id == user_id) this.message_being_edited = this.message_under_menu;
			else if (action == 'Reply') {
				this.message_for_reply = this.message_under_menu;
				this.$refs.type_msg_field.focus();
				this.scrollDown();
			}
		},
		handle_keydown(event) {
			if (event.key == 'ArrowUp') {
				console.log("You pressed arrow up!", {my_last_message});
				this.message_being_edited = my_last_message;
			}
			else if (event.key == 'Enter') this.send();
			else if (event.key == 'Escape') this.message_for_reply = null;
		},
		send() {
			if (this.type_msg.length === 0) return;

			let M = {
				text: this.type_msg,
				author: {
					name: this.nickname,
				},
			};
			if (this.message_for_reply) M.reply_to = this.message_for_reply.id.Website;

			socket.emit('message', this.rooms[this.room].id, M);
			this.type_msg = '';
			this.message_for_reply = null;
			my_last_message = M;
		},
		edit() {
			socket.emit('edit', this.rooms[this.room].id, this.message_being_edited.id.Website, {text: this.message_being_edited.text} );
			this.message_being_edited = null;
		},
		change_room(index) {
			this.message_for_reply = null;
			this.room = index;
			this.scrollDown();
		},
		find_message(room, id) {
			let r = this.msg_db[room];
			for (let i = r.length - 1; i >= 0; i--) {
				if (r[i].id.Website == id) return r[i];
			}
			return null;
		},
		process_msg(room, M) {
			if (M.reply_to) {
				M.reply_to = this.find_message(room, M.reply_to);
			}
		},
		get_room_number_by_id(room) {
			for (let i = 0; i < this.rooms.length; i++) {
				if (this.rooms[i].id === room) return i;
			}
		},
		same_author(M1, M2) {
			return M1.orig_app === M2.orig_app && M1.author.id == M2.author.id && M1.author.name == M2.author.name;
		},
		scrollDown(forced) {
			let e = this.$refs.message_box;

			if (e !== undefined) {
				if (!forced && getVerticalScrollPercentage(e) < 1) return;

				setTimeout( () => {
					try {
						e.scrollBy(0, 1000000000);
					}
					catch(err) {
						console.log("Scrolling error");
					}
				}, 100);
			}
		},
		change_nickname() {
			localStorage.nickname = this.nickname = this.type_nickname;
			this.settings = false;
		},
		shorten(text) {
			if (text.length > 50) return text.slice(0,50) + '...';
			else return text;
		}
	},
	beforeDestroy() {
		//for (let listener of ['message', 'edit', 'delete']) socket.removeAllListeners(listener);
		//socket.close();
	},
	created() {

		let handle_connect = (socket) => {
			console.log("handle_connect!");
			socket.emit('authorization', user_id, password);

			socket.on("disconnect", () => {
				console.log("I disconnected!");
			});

			socket.on('message', (room, M) => {
				console.log(M);
				this.process_msg(room, M);
				this.msg_db[room].push(M);
				this.scrollDown();
			});

			socket.on('edit', (room, M) => {
				let r = this.msg_db[room];
				let M_old = this.find_message(room, M.id.Website);
				if (M_old) M_old.text = M.text;
			});

			socket.on('delete', (room, id) => {
				let r = this.msg_db[room];
				for (let i = r.length - 1; i >= 0; i--) {
					if (r[i].id.Website == id) {
						r[i].is_deleted = true;
						r.splice(i, 1);
						this.scrollDown();
						break;
					}
				}
			});

			for (let r of this.rooms) {
				socket.emit('previous_messages', r.id, previous_messages => {
					this.msg_db[r.id] = previous_messages;
					for (let M of previous_messages) this.process_msg(r.id, M);
				});
			}
			this.scrollDown(true);
		};

		if (socket === undefined) {

			for (let s of [socket1, socket2]) {
				s.io.on("reconnect_attempt", () => {
					if (socket1.connected || socket2.connected) s.destroy();
				});
				s.on("connect", () => {
					socket = s;
					handle_connect(s);
					this.$emit('connect');
					//if (no_event_listeners_yet) handle_connect(s);
					//no_event_listeners_yet = false;
				});
				s.open();

			}				
		}
		else {
			//handle_connect(socket);
		}
	}
}
</script>

<style scoped>

.main {
	display: flex;
	flex-flow: column;
	align-content: stretch;
	background-color: white;
}

.author {
	color: rgb(242, 163, 11);
	font-weight: bold;
}

.emoji_card {
	width: 264px;
	user-select: none;
	cursor: pointer;
}

.message_box {
	flex: 1 1 auto;
	overflow-y: scroll;
}

.reply {
	border: 1px solid grey;
	border-radius: 5px;
	font-style: italic;
	color: grey;
}

.message_content {
	white-space: break-spaces;
}

.msg_for_highlight:hover {
	background-color: rgb(221, 221, 221);
}

.msg_under_menu {
	background-color: rgb(221, 221, 221);
}

.replying_to {
	padding-left: 10px;
	background-color: #AAAAAA;
	width: 95%;
}


.cap {
	position: relative;
	color: white;
	flex: 0 1 auto;
}

.cap > div {
	width: 100%;
	height: 30px;
}

.krest {
	position: absolute;
	top: 0;
	left: 0;
}

</style>